import { Pipe, PipeTransform } from '@angular/core';

import { getSunTimes } from '../constants/constants';
import { isNil } from 'src/utils/utils';

@Pipe({ name: 'suntimes' })
export class SuntimesPipe implements PipeTransform {
  transform(
    selectedStation: any,
    selectedDay: any,
    sunTimesArray: any,
    selectedStationIndex: any,
    pigeonRouteDetails: any
  ) {
    if (!isNil(selectedStation) && !isNil(selectedDay)) {
      const dayOfYear = selectedDay.dayOfYear();
      if (
        !isNil(sunTimesArray?.[selectedStation]) &&
        !isNil(sunTimesArray[selectedStation]?.[dayOfYear])
      ) {
        return sunTimesArray[selectedStation][dayOfYear];
      }
      if (
        !isNil(selectedStationIndex) &&
        !isNil(pigeonRouteDetails.stations[selectedStationIndex])
      ) {
        const station = pigeonRouteDetails.stations[selectedStationIndex];
        const sunriseset = getSunTimes(
          station.lnglat[1],
          station.lnglat[0],
          selectedDay
        );
        return sunriseset;
      }
    }
    return {
      sunrise: '',
      sunset: '',
    };
  }
}
